export enum HomeTab {
  Home = 'home',
  Analytics = 'analytics',
  Account = 'account',
  Respondents = 'respondents',
}
